export const dimensionIcons = {
  'Account Number': 'user',
  Time: 'clock-o',
  Currency: 'money',
  Version: 'clone',
  GLSource: 'database',
  Dimension: 'diamond',
};

export const budgetDetails = {
  versionName: 'Sample Budget',
};